import * as React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Checkbox, Typography } from "@mui/material";
import DriveRow from "../DriveRow";

const hdr = {
  fontSize: "11px",
  fontWeight: 700,
  color: "var(--text-3)",
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  padding: "10px 20px !important",
  borderBottom: "1px solid var(--border) !important",
  bgcolor: "transparent",
  userSelect: "none",
  whiteSpace: "nowrap",
  cursor: "default",
};

export const FolderContentList = ({ rows, selectMode, selected, onToggle, onToggleAll }) => {
  const allSelected = rows.length > 0 && rows.every(r => selected?.has(r.id));
  const someSelected = rows.some(r => selected?.has(r.id));

  return (
    <Box sx={{
      borderRadius: 2,
      overflow: "hidden",
      mb: 3,
      bgcolor: "var(--bg-card)",
      border: "1px solid var(--border-h)",
      boxShadow: "none",
    }}>
      <TableContainer>
        <Table size="small" sx={{ tableLayout: "fixed", borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow sx={{ bgcolor: "var(--bg-card-h)" }}>
              <TableCell sx={{ ...hdr, width: "52%", pl: selectMode ? "12px !important" : "20px !important" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  {selectMode && (
                    <Checkbox
                      checked={allSelected}
                      indeterminate={someSelected && !allSelected}
                      onChange={() => onToggleAll?.(rows)}
                      size="small"
                      sx={{ p: 0, color: "var(--text-3)", "&.Mui-checked": { color: "#7c6af7" }, "&.MuiCheckbox-indeterminate": { color: "#7c6af7" } }}
                    />
                  )}
                  Name
                </Box>
              </TableCell>
              <TableCell sx={{ ...hdr, width: "12%" }}>Kind</TableCell>
              <TableCell sx={{ ...hdr, width: "12%" }}>Size</TableCell>
              <TableCell sx={{ ...hdr, width: "24%" }}>Date Modified</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <DriveRow
                key={row.id}
                row={row}
                selectMode={selectMode}
                selected={selected?.has(row.id)}
                onToggle={onToggle}
                isLast={i === rows.length - 1}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
